const Validation = (vm) => {
  const validateBeforeSubmit = () => {
    if (vm.formDataUser.email === vm.formDataUser.alternativeEmail) {
      vm.message('Correo electrónico principal y alternativos no deben ser el mismo', 'error');
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(vm.formDataUser.email)) {
      vm.message('Correo electrónico inválido', 'error');
      return false;
    }
    if (vm.formDataArea.length === 0) {
      vm.message('Selecciona mínimo una área temática', 'error');
      return false;
    }
    if (vm.mode === 'create') {
      if (!vm.formDataUser.password || !vm.formDataUser.confirmPassword) {
        vm.message('La contraseña es obligatoria', 'error');
        return false;
      }
      if (vm.formDataUser.password !== vm.formDataUser.confirmPassword) {
        vm.message('Las contraseñas no coinciden', 'error');
        return false;
      }
      if (!vm.acceptedPolicy) {
        vm.message('Debe aceptar el tratamiento de datos personales para continuar', 'error');
        return false;
      }
    }
    return true;
  };

  return {
    validateBeforeSubmit,
  };
};

export default Validation;
